export const ADMIN_DEFAULT_ROUTE = '/admin/artworks'
